'use client'

import Link from 'next/link'
import { Icon } from 'shared/iconpack'
import { TokenStorage } from 'shared/libs/storage'

import { useEffect, useState } from 'react'

import { RouterPath } from 'shared/config/routerPath/RouterPath'

import styles from './HeaderFavorite.module.scss'

export function HeaderFavorite() {
  const [token, setToken] = useState<string | null>(null)

  useEffect(() => {
    const storedToken = TokenStorage.getFromStorage()
    setToken(storedToken)
  }, [])

  const href = token ? RouterPath.FAVORITES : RouterPath.AUTH
  return (
    <Link href={href} className={styles.actionButton}>
      <Icon name="favorite" color="#40474F" size={28} />
      <p className="fw-500">Избранное</p>
    </Link>
  )
}
